<template>
    <span :class="getClass(value)">{{description}}</span>
</template>
<script>
    export default {
        name:'PxBadge',
        props:{
            dataConfiguration:{
                default: () => [],
                type: Array
            },
            value:{
                default:null,
                type:String
            },
            description:{
                default:null,
                type:String
            }
        },
        methods:{
            getClass(value){
                return this.dataConfiguration.find( x => x.value==value ).colorClass
            }
        }
    }
</script>